module.exports = __webpack_public_path__ + "img/down-angle.64d945a1.svg";